import { post } from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization : `Bearer ${store.state.user.attributes.token}` }

// sponsortJobOffer
function addProgramSeasonSponsorTitleOrder (pFormdata, IdProgramSeasonSponsor) {
    const URI = `${BASE_URL}/api/programSeasonSponsor/${IdProgramSeasonSponsor}/addTitleOrder`
    return post(URI, pFormdata, { headers })
}

export { addProgramSeasonSponsorTitleOrder }